import { show } from '@ebay/nice-modal-react'
import React, { FC } from 'react'
import { Button, Typography } from '@mui/material'
import UnisatTransferBrc20Dialog from '../../TransferBrc20Dialog/UnisatTransferBrc20Dialog'
import OkxTransferBrc20Dialog from '../../TransferBrc20Dialog/OkxTransferBrc20Dialog'
import { BtcConnectorName, useBtc } from '@/context/BtcContext'
import { SupportedTicker } from '@/constants/token'

const TRANSFER_DIALOGS: Record<BtcConnectorName, FC<{ tokenName: string }>> = {
  Unisat: UnisatTransferBrc20Dialog,
  OKX: OkxTransferBrc20Dialog,
}

interface TransferButtonProps {
  ticker: SupportedTicker
  disabled?: boolean
}

const TransferButton = ({ ticker, disabled }: TransferButtonProps) => {
  const { isConnected, connectorName } = useBtc()

  const openTransferDialog = () => {
    show(TRANSFER_DIALOGS[connectorName], {
      tokenName: ticker,
    })
  }

  return (
    <Button
      size="large"
      fullWidth
      variant="contained"
      sx={{ height: 50, mt: 32 }}
      disabled={!isConnected || disabled}
      onClick={openTransferDialog}
    >
      <Typography>Transfer</Typography>
    </Button>
  )
}

export default TransferButton
